import React from 'react';

const CourseReviewFormModal = React.lazy(() => import('../components/FormModal'));
const courseReviewModalRegistry = {
    community_courseReviewId: CourseReviewFormModal
};
export default courseReviewModalRegistry;
